module.exports = __webpack_public_path__ + "static/media/corrugated-edge.54a51ec6.jpg";